import * as R from 'ramda'

export type Breakpoints = '2xs' | 'xs' | 'sm' | 'md' | '2md' | 'lg' | '2xl'

/**
 * screen width breakpoints
 */
export const breakpoints: Record<Breakpoints, number> = {
  '2xs': 560,
  xs: 640,
  sm: 688,
  md: 768,
  '2md': 1000,
  lg: 1024,
  '2xl': 1680,
}

export const breakpointsPx = R.map((val) => `${val}px`, breakpoints)

export const breakpointsRem = R.map((val) => `${val / 16}rem`, breakpoints)
